import React from "react";
import PotentialProjects from "../components/Invest/PotentialProjects";
import { upcomingProjects } from "../data";

const Invest = () => {
  return (
    <div className="text-center bg-[#fafafa] ">
      <div className="top pt-8 pb-4 lg:pb-8">
        <h3 className="mt-[50px] md:mt-[180px] mb-[20px] text-[30px] lg:text-[60px] font-bold text-black px-8 md:px-12 lg:px-36 text-center">
          Invest in Hideout Outposts
        </h3>
        <p className="text-[14px] lg:text-[18px] font-normal text-[#1b1b1b] px-8 md:px-12 lg:px-36 text-center pb-3">
          Hideout is seeking active real estate investors to join our investor
          network.
        </p>
        <p className="text-[14px] lg:text-[16px] font-normal text-[#1b1b1b] px-8 md:px-12 lg:px-36 text-center pb-3">
          Join us in creating exclusive retreats across breathtaking landscapes,
          powered by our comprehensive management and marketing platform.
        </p>
        {/* <button className="bg-black text-white  px-8 py-2 mt-4 shadow hover:bg-gray-800 transition duration-300 w-auto">
          Apply now
        </button> */}
        <button className="bg-black text-white rounded-md px-8 py-2 mt-4 shadow hover:bg-gray-800 transition duration-300 w-auto mx-auto">
          Apply now
        </button>
      </div>

      <div className="mt-[100px]">
        <h1 className="text-5xl text-[#1b1b1b] font-bold mb-8 leading-tight">
          Potential Upcoming Projects
        </h1>
      </div>

      {/* Potential Projects */}
      {upcomingProjects.map((card, index) => (
        <div key={index} className="w-full">
          <PotentialProjects
            title={card.title}
            images={card.images}
            descriptions={card.descriptions}
          />
        </div>
      ))}
    </div>
  );
};

export default Invest;
